import React from "react";
import faceMatch from "@iso/assets/images/face-match.svg";
import FacebookIcon from "@iso/assets/images/icon/facebook.svg";
import LinkedinIcon from "@iso/assets/images/icon/linkedin.svg";
import TwitterIcon from "@iso/assets/images/icon/twitter.svg";
import YoutubeIcon from "@iso/assets/images/icon/youtube.svg";
import InstagramIcon from "@iso/assets/images/icon/instagram.svg";

export function SidePanel() {
  return (
    <div className="hidden w-full items-center text-center md:grid content-between">
      <div className="px-16 lg:px-32 py-6">
        <p className="text-center text-5xl font-small text-gray-800 leading-tight tracking-tight uppercase">
          FRAUD PREVENTION <br /> FOR BUSINESS OF ALL SIZES
        </p>
      </div>
      <div className="flex items-center justify-center px-16 lg:px-32">
        <img className="w-auto h-auto" src={faceMatch} alt="Docplanner Group" />
      </div>
      <div className="">
        <p className="lg:text-3xl text-2xl font-small py-6">
        From hundreds to millions of transactions.
        </p>
      </div>
      <div className="flex gap-x-16 items-center justify-center px-16 lg:px-32">
        <div className="pb-6">
          <h1 className="text-primary text-5xl font-medium mb-2">100M+</h1>
          <span className="font-small">
            Transactions <br /> processed worldwide
          </span>
        </div>
        <div className="pb-6">
          <h1 className="text-primary text-5xl font-medium mb-2">3M+</h1>
          <span className="font-small">
            Anonymous profiles <br /> in Saffe Network
          </span>
        </div>
        <div className="pb-6">
          <h1 className="text-primary text-5xl font-medium mb-2">1M+</h1>
          <span className="font-small">
            Fraud attempts <br /> detected
          </span>
        </div>
      </div>
      <div className="bg-primary items-center rounded-t-[70px] py-5">
        <span className="text-white">©2023 Saffe. All rights reserved.</span>
        <div className="flex items-center justify-center px-36">
          <hr className="h-px w-full my-6 bg-white border-0" />
        </div>
        <div className="flex justify-center items-center gap-x-10">
          <a
            href={"https://www.facebook.com/SaffeAI"}
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="w-auto h-auto"
              alt="Logo Saffe"
              width={16}
              src={FacebookIcon}
            />
          </a>
          <a
            href={"https://www.linkedin.com/company/saffeai"}
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="w-auto h-auto"
              alt="Logo Saffe"
              width={16}
              src={LinkedinIcon}
            />
          </a>
          <a
            href={"https://twitter.com/saffeai"}
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="w-auto h-auto"
              alt="Logo Saffe"
              width={16}
              src={TwitterIcon}
            />
          </a>
          <a
            href={"https://www.youtube.com/@saffeai"}
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="w-auto h-auto"
              alt="Logo Saffe"
              width={16}
              src={YoutubeIcon}
            />
          </a>
          <a
            href={"https://www.instagram.com/saffe.ai"}
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="w-auto h-auto"
              alt="Logo Saffe"
              width={16}
              src={InstagramIcon}
            />
          </a>
        </div>
      </div>
    </div>
  );
}
